module.exports = __webpack_public_path__ + "staticcomp/img/top.4e08e66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/8/top.jpg
// module id = 4iyo
// module chunks = 39